import { render } from "./ModalDialog.vue?vue&type=template&id=335da46a&scoped=true"
import script from "./ModalDialog.vue?vue&type=script&lang=js"
export * from "./ModalDialog.vue?vue&type=script&lang=js"

import "./ModalDialog.vue?vue&type=style&index=0&id=335da46a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335da46a"]])

export default __exports__